import React, { useEffect, useState } from "react";
import {
  Dropdown,
  Form,
  Input,
  InputNumber,
  Popconfirm,
  Select,
  Spin,
  Table,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../features/save/saveSlice";
import TableLoading from "../../../../components/TableLoading";
import svg29 from "../../../../assets/svg/svg29.svg";
import {
  fetchData,
  fetchMangrCrops,
} from "../../../../features/fetch/fetchSlice";

const EditableCell = ({
  mngrCrops,
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "money" ? (
      <InputNumber
        prefix={"KES"}
        min={1}
        id="input-focus"
        className="input"
        variant="borderless"
      />
    ) : inputType === "dropdown" ? (
      <Select
        suffixIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M17.1922 8.21268L10.9422 14.4627C10.8841 14.5208 10.8152 14.5669 10.7393 14.5983C10.6634 14.6298 10.5821 14.646 10.5 14.646C10.4178 14.646 10.3365 14.6298 10.2606 14.5983C10.1848 14.5669 10.1158 14.5208 10.0578 14.4627L3.80779 8.21268C3.69052 8.0954 3.62463 7.93634 3.62463 7.77049C3.62463 7.60464 3.69052 7.44558 3.80779 7.3283C3.92507 7.21103 4.08413 7.14514 4.24998 7.14514C4.41583 7.14514 4.57489 7.21103 4.69217 7.3283L10.5 13.1369L16.3078 7.3283C16.3659 7.27023 16.4348 7.22417 16.5107 7.19274C16.5865 7.16132 16.6679 7.14514 16.75 7.14514C16.8321 7.14514 16.9134 7.16132 16.9893 7.19274C17.0652 7.22417 17.1341 7.27023 17.1922 7.3283C17.2502 7.38637 17.2963 7.45531 17.3277 7.53118C17.3592 7.60705 17.3753 7.68837 17.3753 7.77049C17.3753 7.85261 17.3592 7.93393 17.3277 8.0098C17.2963 8.08567 17.2502 8.15461 17.1922 8.21268Z"
              fill="#212121"
            />
          </svg>
        }
        options={mngrCrops?.map((item, index) => {
          return {
            label: (
              <div key={index}>
                <span>{item?.cropName}</span>
              </div>
            ),
            value: item?.cropName,
          };
        })}
      />
    ) : (
      <InputNumber
        id="input-focus"
        className="input flex"
        variant="borderless"
      />
    );
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          className="table-form-item"
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Field is required`,
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (dataIndex === "prodProduceSold") {
                  const total = getFieldValue("prodTotalProduce");
                  if (total !== undefined && value > total) {
                    return Promise.reject(
                      new Error(
                        "Produce sold cannot be more than total produce"
                      )
                    );
                  }
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function SchemeCropsTable({ periodId }) {
  const url = "prod/get_scheme_manager_production_detail";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { mngrCrops } = useSelector((state) => state.fetch);
  const { saving } = useSelector((state) => state.save);
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["privateSchemes"],
  }));
  const dispatch = useDispatch();
  const navigate = useNavigate;
  const [form] = Form.useForm();

  const [editingKey, setEditingKey] = useState("");
  const [selectedObj, setselectedObj] = useState({});

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const [dataSource, setDataSource] = useState(data);

  // const handleAddRow = () => {
  //   const newRow = {
  //     prodId: null,
  //     prodCrops: "",
  //     prodCroppedArea: "",
  //     prodTotalProduce: "",
  //     prodAmount: "",
  //     prodTotalRevenue: "",
  //     prodProduceSold: "",
  //   };

  //   setDataSource([...dataSource, newRow]);
  //   edit(newRow);
  // };

  const handleAddRow = async () => {
    try {
      await form.validateFields();
      const newRow = {
        prodId: null,
        prodCrops: "",
        prodCroppedArea: "",
        prodTotalProduce: "",
        prodAmount: "",
        prodTotalRevenue: "",
        prodProduceSold: "",
      };
      setDataSource([...dataSource, newRow]);
      edit(newRow);
    } catch (errInfo) {
      toast.error("Please fill all fields before adding a new row");
    }
  };

  const handleRemove = async () => {
    try {
      const idsToDelete = selectedRowKeys.filter((key) =>
        dataSource.some((item) => item.prodId === key)
      );

      const localRows = selectedRowKeys.filter((key) =>
        dataSource.some((item) => item.prodId === key && !item.prodId)
      );

      const updatedDataSource = dataSource.filter(
        (item) => !selectedRowKeys.includes(item.prodId)
      );

      setDataSource(updatedDataSource);
      setSelectedRowKeys([]);
    } catch (error) {
      console.error("Error deleting:", error);
      toast.error("Failed to delete items");
    }
  };

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const isEditing = (record) => record?.prodId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record?.prodId);
  };

  const cancel = () => {
    setEditingKey("");
  };
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  async function handleFetch(page, size) {
    await dispatch(
      fetchData({
        url: url,
        schId: activeObjSchemes?.schId,
        proId: periodId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  const handleDelete = async () => {};

  const saveFunction = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...dataSource];
      const index = newData?.findIndex((item) => key === item?.prodId);
      if (index > -1) {
        const item = newData[index];

        const updatedObj = {
          ...item,
          ...row,
          prodTotalRevenue:
            (row?.prodAmount || 0) * (row?.prodProduceSold || 0),
        };
        updatedObj.prodProId = periodId;
        const res = await dispatch(
          save({
            ...updatedObj,
            url: "prod/scheme_manager_production_detail",
          })
        );
        if (res?.payload?.success) {
          await handleFetch();
          await fetchMangrCropsData();
          await toast.success(res?.payload?.message);
          await setEditingKey("");
        } else {
          toast.error(res?.payload?.message);
        }
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const items = [
    {
      key: "1",
      label: (
        <div onClick={() => edit(selectedObj)} className="pointer w-full">
          Edit
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <Popconfirm
          okText="Confirm"
          cancelText="Cancel"
          cancelButtonProps={{
            style: {
              background: "#D3D3D9",
              color: "#212143",
              fontWeight: 500,
              fontSize: ".875rem",
              borderRadius: "0.375rem",
              padding: ".5rem",
              width: "fit-content",
              height: "2.0625rem",
              marginRight: 10,
            },
          }}
          okButtonProps={{
            style: {
              background: "#212121",
              color: "#fff",
              fontWeight: 500,
              fontSize: ".875rem",
              borderRadius: "0.375rem",
              padding: ".5rem",
              width: "fit-content",
              height: "2.0625rem",
            },
          }}
          title={`Are you sure to you want to remove" ${selectedObj?.prodCrops}?`}
          onConfirm={handleDelete}
        >
          <div className="pointer w-full">Remove crop</div>
        </Popconfirm>
      ),
    },
  ];

  const columns = [
    // {
    //   title: "#",
    //   dataIndex: "index",
    //   key: "index",
    //   render: (_, __, index) => index + 1,
    // },
    {
      title: "Crop",
      dataIndex: "prodCrops",
      editable: true,
      width: 200,
    },
    {
      title: "Area Under Crop (Acres)",
      dataIndex: "prodCroppedArea",
      editable: true,
    },
    {
      title: "Total Produce (Kg)",
      dataIndex: "prodTotalProduce",
      editable: true,
    },
    {
      title: "Produce Sold (Kg)",
      dataIndex: "prodProduceSold",
      editable: true,
    },
    {
      title: "Price per Unit",
      dataIndex: "prodAmount",
      editable: true,
    },
    {
      title: "Gross Income",
      dataIndex: "prodTotalRevenue",
      render: (_, record) => record.prodTotalRevenue?.toLocaleString() || "0",
    },

    {
      title: "Action",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div className="flex w-fit items-center gap-[1rem]">
            <button onClick={cancel} className="modal_btn_light" type="button">
              Cancel
            </button>
            <button
              disabled={saving}
              type="button"
              onClick={() => saveFunction(record?.prodId)}
              className="modal_btn_dark"
            >
              {saving ? <Spin /> : "Save"}
            </button>
          </div>
        ) : (
          <Dropdown
            overlayStyle={{
              width: "11.8125rem",
              margin: ".5rem",
              boxShadow: " 0px 1px 12px 0px rgba(25, 27, 35, 0.10)",
            }}
            overlayClassName="avatar_dropdown"
            arrow
            menu={{
              items: items,
            }}
            onOpenChange={(open) => {
              if (open) {
                setselectedObj(record);
              } else {
                setselectedObj({});
              }
            }}
            trigger={["click"]}
            placement="bottom"
          >
            <button type="button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
              >
                <path
                  d="M16 17.5C16.8284 17.5 17.5 16.8284 17.5 16C17.5 15.1716 16.8284 14.5 16 14.5C15.1716 14.5 14.5 15.1716 14.5 16C14.5 16.8284 15.1716 17.5 16 17.5Z"
                  fill="#343330"
                />
                <path
                  d="M24.5 17.5C25.3284 17.5 26 16.8284 26 16C26 15.1716 25.3284 14.5 24.5 14.5C23.6716 14.5 23 15.1716 23 16C23 16.8284 23.6716 17.5 24.5 17.5Z"
                  fill="#343330"
                />
                <path
                  d="M7.5 17.5C8.32843 17.5 9 16.8284 9 16C9 15.1716 8.32843 14.5 7.5 14.5C6.67157 14.5 6 15.1716 6 16C6 16.8284 6.67157 17.5 7.5 17.5Z"
                  fill="#343330"
                />
              </svg>
            </button>
          </Dropdown>
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        inputType:
          col.dataIndex === "prodAmount"
            ? "money"
            : col.dataIndex === "prodCrops"
            ? "dropdown"
            : "text",
        title: col.title,
        editing: isEditing(record),
        mngrCrops: mngrCrops,
      }),
    };
  });

  async function fetchMangrCropsData() {
    await dispatch(fetchMangrCrops({ schId: activeObjSchemes?.schId }));
  }

  useEffect(() => {
    handleFetch();
    fetchMangrCropsData();
  }, [periodId]);

  useEffect(() => {
    setDataSource(data);
  }, [data]);

  return (
    <>
      <div className="grid grid-cols-1 gap-[1.25rem] pb-[1rem] mt-[1.69rem] lg:min-h-[54vh] flex-1">
        <div className=" flex-col">
          {loading ? (
            <TableLoading />
          ) : (
            <Form
              form={form}
              component={false}
              onValuesChange={(changedValues, allValues) => {
                if (
                  changedValues.prodAmount !== undefined ||
                  changedValues.prodProduceSold !== undefined
                ) {
                  const updatedData = dataSource?.map((item) => {
                    if (item?.prodId === editingKey) {
                      return {
                        ...item,
                        prodTotalRevenue:
                          (allValues.prodAmount || 0) *
                          (allValues.prodProduceSold || 0),
                      };
                    }
                    return item;
                  });

                  setDataSource(updatedData);
                  form.setFieldsValue({
                    prodTotalRevenue:
                      (allValues.prodAmount || 0) *
                      (allValues.prodProduceSold || 0),
                  });
                }
              }}
            >
              <Table
                rowSelection={rowSelection}
                className="mt-[1.25rem]"
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                rowKey={(record) => record?.prodId}
                dataSource={dataSource}
                columns={mergedColumns}
                scroll={{
                  x: 1200,
                }}
                pagination={{
                  position: ["bottomRight"],
                  current: pageIndex + 1,
                  total: count,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    handleFetch(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
                footer={() => {
                  const isLastPage = (pageIndex + 1) * pageSize >= count;
                  return (
                    <>
                      <div className="flex items-center w-full justify-between gap-[1.25rem] p-[1rem]">
                        {selectedRowKeys.length > 0
                          ? null
                          : isLastPage && (
                              <button
                                type="button"
                                onClick={handleAddRow}
                                className="cstm-btn-2 !w-[120px]"
                              >
                                <img src={svg29} alt="svg29" />
                                <span className="">Add Crop</span>
                              </button>
                            )}
                      </div>
                    </>
                  );
                }}
              />
            </Form>
          )}
        </div>
      </div>
    </>
  );
}
